	import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class TypeEmploymentService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('TypeEmployment');
	}
	
	loadAll(active: boolean): Observable<ePM.Logic.TypeEmployment[]> {
		return this.myBaseService.loadAll(this.url + '?activeOnly=' + active);
	}
	save(tempItem: ECI.Basic.ObjectBase) : Observable<ePM.Logic.TypeEmployment> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.TypeEmployment> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<ePM.Logic.TypeEmployment>{
		return this.myBaseService.get(id, this.url);
	}
	search(searchTerm: string) : Observable<ePM.Logic.TypeEmployment[]>{
		return this.myBaseService.loadAll(this.url + '/Search/' + searchTerm);
	}
}
